import { Component } from '@angular/core';
import { ConfirmationService, LazyLoadEvent, Message } from 'primeng';
import { IEmailTemplate } from '../../interfaces/email-template';
import { IEmailTemplateFilter } from '../../interfaces/email-template-filter';
import { IPageResult } from '../../interfaces/page-result';
import { EmailTemplateService } from '../../services/email-template.service';

/**
 * Component for managing email templates
 */
@Component({
  selector: 'email-templates',
  templateUrl: './email-templates.component.html',
})
export class EmailTemplatesComponent {
  //to store settings for table
  public dataTableSettings: any = {
    isPaginator: true,
  };
  public page: IPageResult<IEmailTemplate> = {
    items: [],
    total: 0,
  };

  constructor(
    private emailTemplateService: EmailTemplateService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    var filter = this.getDefaultFilter();
    this.load(filter);
  }

  getDefaultFilter() {
    return <IEmailTemplateFilter>{
      first: 0,
      rows: 10,
      sortField: 'code',
      sortOrder: 1,
      filters: {
        code: {},
        title: {},
        isSystem: {},
      },
    };
  }

  //sends get request for getting email templates with filters
  load(filterCommand: IEmailTemplateFilter) {
    this.emailTemplateService.getPage(filterCommand).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    var filter = this.getDefaultFilter();
    filter.first = event.first;
    filter.rows = event.rows;
    if (event.sortField) filter.sortField = event.sortField;
    filter.sortOrder = event.sortOrder;

    this.load(filter);
  }

  //deletes email template
  deleteEmailTemplate(emailTemplate: IEmailTemplate) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this email template ?',
      accept: () => {
        this.emailTemplateService.delete(emailTemplate.id).then((data) => {
          this.load(this.getDefaultFilter());
        });
      },
    });
  }
}
